import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Dashboard";
import CircularProgress from "@material-ui/core/CircularProgress";
import AdmissionContext from "../AdmissionContext";
import CryptoJS from "crypto-js";
import moment from "moment";
import {
  GetAcademicYear,
  GetUndergraduateCourses,
  GetGraduateCourses,
  GetTracks,
  GetToken,
  GetSettings,
  GetRegion,
} from "../global";

import StepperView from "./stepper";
import ConsentView from "./consent";
import CourseView from "./course";
import PersonalInformationView from "./personalInformation";
import AddressView from "./address";
import ContactView from "./contact";
import SchoolView from "./school";
import AttachmentView from "./attachment";
import OthersView from "./others";
import SuccessView from "./success";
import ExpiredView from "./expired";
import MaintenanceView from "./maintenance";

const useStyles = (theme) => ({
  header: {
    background: "linear-gradient(45deg, #388e3c 30%, #4caf50 50%)",
    border: 0,
    boxShadow: "0 3px 5px 2px rgba(129, 199, 132, .3)",
    color: "white",
    height: 60,
    padding: "0 30px",
  },
  loading: {
    color: "#388e3c",
    animationDuration: "1000ms",
  },
  // root: {
  //   background: "linear-gradient(45deg, #388e3c 30%, #4caf50 50%)",
  //   border: 0,
  //   boxShadow: "0 3px 5px 2px rgba(129, 199, 132, .3)",
  //   color: "white",
  //   height: 60,
  //   padding: "0 30px",
  //   "&$active": {
  //     color: "green"
  //   },
  // },
  card: {
    border: 0,
    width: 500,
    minWidth: 100,
    maxWidth: 600,
  },
  primaryColor: {
    color: "#388e3c",
  },
  logo: {
    border: 0,
    maxWidth: 40,
    marginRight: "5px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  button: {
    height: 45,
  },
  title: {
    flexGrow: 1,
    textAlign: "center",
  },
});

class Admission extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);

    this.state = {
      isClosed: false,
      isLoading: false,
      isAgree: false,
      datefrom: new Date(),
      dateto: new Date(),
      maintenance: false,
    };
  }

  componentDidMount() {
    this.context.initState();

    if (!this.state.maintenance) {
      this.loadData();
    }
  }

  loadData = async () => {
    this.setState({
      isLoading: true,
      isAgree: false,
    });

    //get token
    await GetToken()
      .then((response) => {
        GetSettings(response.data)
          .then((response) => {

            var token = response.data.token;
            var bytes = CryptoJS.AES.decrypt(token, 'k7Xdg4M6NQ');
            var payload = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            this.context.SetDatabase(payload.database);
            this.context.SetMail(payload.mail);

            //load defaults
            Promise.all([
              GetAcademicYear().then((response) => {
                let semester = response.semester;
                let year = response.year;
                let datefrom = moment(response.datefrom, "MM/DD/YYYY");
                let dateto = moment(response.dateto, "MM/DD/YYYY");

                this.setState({
                  datefrom: moment(datefrom).format("YYYYMMDD"),
                  dateto: moment(dateto).format("YYYYMMDD"),
                });

                this.context.SetAcademicYear(semester, year);
              }),
              GetUndergraduateCourses().then((response) => {
                this.context.SetUndergraduateCourse(response.data);
              }),
              GetGraduateCourses().then((response) => {
                this.context.SetGraduateCourse(response.data);
              }),
              GetTracks().then((response) => {
                this.context.SetTrack(response);
              }),
              GetRegion().then((response) => {
                this.context.SetRegion(response.data);
              }),
            ]).then(() => {
              let current = parseInt(moment(new Date()).format("YYYYMMDD"));
              let dateto = parseInt(this.state.dateto);
              if (current > dateto) {
                this.setState({
                  //isClosed: true,
                  isLoading: false,
                });
              } else {
                this.setState({
                  isClosed: false,
                  isLoading: false,
                });
              }
            });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div>
          {this.showHeader()}
          {this.showLoading()};
        </div>
      )
    }

    return (
      <div>
        {this.showHeader()}
        <StepperView />
        {this.navigationView()}
        {this.navigationStepper()}
      </div>
    );
  }

  navigationView = () => {
    const { admission, activeStep } = this.context;

    if (this.state.maintenance) {
      return <MaintenanceView />
    }

    if (admission) {
      if (activeStep === 0) {
        return <CourseView />;
      } else if (activeStep === 1) {
        return <PersonalInformationView />;
      } else if (activeStep === 2) {
        return <AddressView />;
      } else if (activeStep === 3) {
        return <ContactView />;
      } else if (activeStep === 4) {
        return <SchoolView />;
      } else if (activeStep === 5) {
        return <AttachmentView />;
      } else if (activeStep === 6) {
        return <OthersView />;
      } else if (activeStep === 7) {
        return <SuccessView />;
      }
    } else {
      if (this.state.isClosed) {
        return <ExpiredView />;
      } else {
        return <ConsentView />;
      }
    }
  };

  navigationStepper = () => { };

  showHeader = () => {
    const { classes } = this.props;
    const { admission, initState } = this.context;

    if (admission) {
      return (
        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Online Admission
            </Typography>
            <IconButton
              edge="end"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={() => {
                initState();
              }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      );
    } else {
      return <AppBar position="static" className={classes.header} />;
    }
  };

  showLoading = () => {
    const { classes } = this.props;
    return (
      <Box display="flex" justifyContent="center" pt={2} css={{ height: 300 }}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Box pt={20} display="flex"
              justifyContent="center">
              <CircularProgress
                variant="indeterminate"
                disableShrink
                className={classes.loading}
                size={50}
                thickness={4}
              />
            </Box>

            <Typography component="div">
              <Box
                fontSize={16}
                color="#808080"
                display="flex"
                justifyContent="center"
                pt={4}
              >
                Loading...
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>

      </Box>


    );
  };
}

export default withStyles(useStyles)(Admission);
